import { render, staticRenderFns } from "./MindsetEditDialog.vue?vue&type=template&id=4f572870&"
import script from "./MindsetEditDialog.vue?vue&type=script&lang=ts&"
export * from "./MindsetEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports